import React from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import NoticeContent from "./NoticeContent";
import { noticeService } from '../../service/firebase/noticeService';
import type { Notice } from '../../type';

const NoticePage = () => {
  const queryClient = useQueryClient();

  // 공지사항 목록 조회
  const { data: notices = [], isLoading, error } = useQuery({
    queryKey: ['notices'],
    queryFn: () => noticeService.getAll(),
  });

  // 공지사항 추가
  const addNoticeMutation = useMutation({
    mutationFn: (notice: Notice) => noticeService.create(notice),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notices'] });
    },
  });

  // 공지사항 수정
  const updateNoticeMutation = useMutation({
    mutationFn: ({ noticeId, notice }: { noticeId: string; notice: Partial<Notice> }) =>
      noticeService.update(noticeId, notice),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notices'] });
    },
  });

  // 공지사항 삭제
  const deleteNoticeMutation = useMutation({
    mutationFn: (noticeId: string) => noticeService.delete(noticeId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notices'] });
    },
  });

  const handleAddNotice = async (notice: Notice) => {
    await addNoticeMutation.mutateAsync(notice);
  };

  const handleUpdateNotice = async (notice: Notice) => {
    await updateNoticeMutation.mutateAsync({
      noticeId: notice.noticeId,
      notice: notice,
    });
  };

  const handleDeleteNotice = async (noticeId: string) => {
    await deleteNoticeMutation.mutateAsync(noticeId);
  };

  return (
    <NoticeContent 
      notices={notices}
      loading={isLoading}
      error={error?.message || null}
      addNotice={handleAddNotice}
      updateNotice={handleUpdateNotice}
      deleteNotice={handleDeleteNotice}
    />
  );
};

export default NoticePage;